export { default } from "./page.svelte";
